/*
 * @Author: your name
 * @Date: 2021-05-14 16:06:38
 * @LastEditTime: 2022-03-04 09:59:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-plan/plan/_api/index.js
 */

import { apiService } from '@/frameworks/http/request'
import axios from 'axios'
import store from '@/frameworks/store/index'
let prefix = 'NQCS/DoAction?act='
let HospitalCode = store.state.user.HospitalCode
export function Download(param) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `NQCS/Download?act=ExportZKJH`,
    method: 'post',
    responseType: 'blob',
    data: param,
    timeout: 15 * 60 * 1000
  })
}

/**
 * 获取系统配置
 * @param {*} {Mjdm，Mjlx}
 * @returns
 */
export function GetXTMJList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetXTMJList`,
    method: 'post',
    data: params
  })
}
